if (!customElements.get('glide-slider')) {
	class Slider extends HTMLElement {
		constructor() {
			super();
			this.script = 'https://cdnjs.cloudflare.com/ajax/libs/Glide.js/3.6.0/glide.min.js';
			this.css = 'https://cdnjs.cloudflare.com/ajax/libs/Glide.js/3.6.0/css/glide.core.min.css';
			this.glideClass = 'glide';
			this.baseCss = `${this.tagName.toLowerCase()}.${this.glideClass} { display: block; }`;
			this._glideInstance = null;
			this._loadEvent = 'sliderscriptloaded';
			this._glideLoadEvent = 'glidejsloaded';
			this.injectAssets();
			this.classList.add(this.glideClass);
		}
		get loadEvent() {
			return this._loadEvent;
		}
		set loadEvent(e) {
			this._loadEvent = e;
		}
		get glideInstance() {
			return this._glideInstance;
		}
		set glideInstance(glide) {
			this._glideInstance = glide;
		}
		get glideLoadEvent() {
			return this._glideLoadEvent;
		}
		set glideLoadEvent(e) {
			this._glideLoadEvent = e;
		}
		loadScript() {
			return new Promise((resolve) => {
				const script = document.createElement('script');
				script.src = this.script;
				script.defer = true;
				script.onload = () => {
					resolve();
					window.dispatchEvent(new Event(this.loadEvent));
				};
				document.head.appendChild(script);
			});
		}
		loadCss() {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = this.css;
			link.media = 'screen';
			document.head.appendChild(link);
			const style = document.createElement('style');
			style.textContent = this.baseCss;
			document.head.appendChild(style);
		}
		async injectAssets() {
			try {
				if (!customElements.get('script-lazy-load')) {
					throw this.loadScript.bind(this);
				}
				const scriptLazyLoad = document.createElement('script-lazy-load');
				scriptLazyLoad.script = this.script;
				scriptLazyLoad.loadEvent = this.loadEvent;
				if (this.firstChild) this.insertBefore(scriptLazyLoad, this.firstChild);
				else this.appendChild(scriptLazyLoad);
			} catch (promise) {
				await promise();
			} finally {
				this.loadCss();
			}
		}
		onScriptLoaded() {
			this.glideInstance = new Glide(this, JSON.parse(this.dataset.glide || '{}'));
			this.glideInstance.on('mount.after', () => window.dispatchEvent(new Event(this.glideLoadEvent)));
			this.glideInstance.mount();
		}
		connectedCallback() {
			window.addEventListener(this.loadEvent, this.onScriptLoaded.bind(this));
		}
		disconnectedCallback() {
			window.removeEventListener(this.loadEvent, this.onScriptLoaded.bind(this));
		}
	}
	customElements.define('glide-slider', Slider);
}